import { ReportLevel } from "../adminReportsApiSlice";
import { reportSubLevelName } from "../adminReportsUtil";
import { EssayAndDraftCountUsageChart } from "../shared/EssayAndDraftCountUsageChart";
import { EssaysAndDraftsRow } from "./adminUsageReportApiSlice";

export function EssaysAndDraftsChart(props: {
	level: ReportLevel;
	data: EssaysAndDraftsRow[];
	hasData: boolean;
}) {
	return (
		<EssayAndDraftCountUsageChart
			level={props.level}
			data={props.data}
			hasData={props.hasData}
			title={`${reportSubLevelName(props.level)} Essays And Drafts Summary`}
			yAxisDataField="name"
			isEssayAndDraftSummaryChart={true}
		/>
	);
}
